/**
 * User agent
 */

let USER_AGENT = {};


export const setUserAgent = ua => {
    USER_AGENT = ua;
};


export default () => {
    return USER_AGENT;
};
